if(!customElements.get('swatch-hover-component')) {
    customElements.define(
      'swatch-hover-component',
      class SwatchHoverComponent extends HTMLElement {
        constructor() {
          super();
          this.image = null;
          this.swatchItems = [];
          this.originalImageSrc = '';
          this.originalActiveItem = null;
        }
  
        connectedCallback() {
          setTimeout(() => this.init(), 0);
        }
  
        init() {
          this.image = this.querySelector('.swatch-hover-image');
          this.imageContainer = this.querySelector('.recommended-products__product__img-container');
          this.swatchItems = this.querySelectorAll('.swatch-hover-item');
          
          if (!this.image || this.swatchItems.length === 0) return;
          
          // Store the original image source
          this.originalImageSrc = this.image.src;
          
          // Store the originally active swatch item
          this.originalActiveItem = this.querySelector('.swatch-hover-item.active');
          
          // Preload all swatch images
          this.preloadSwatchImages();
          
          // Add hover listeners to each swatch item
          this.swatchItems.forEach(item => {
            item.addEventListener('mouseenter', this.handleSwatchHover.bind(this));
            item.addEventListener('mouseleave', this.handleSwatchLeave.bind(this));
          });
        }
  
        preloadSwatchImages() {
          // Preload images in the background so they're cached for instant hover
          this.swatchItems.forEach(item => {
            const imageUrl = item.dataset.imageUrl;
            if (imageUrl) {
              const preloadImg = new Image();
              preloadImg.src = imageUrl;
            }
          });
        }
  
        handleSwatchHover(event) {
          const swatchItem = event.currentTarget;
          const imageUrl = swatchItem.dataset.imageUrl;
          
          if (!imageUrl) return;
          
          // Remove active class from all swatch items
          this.swatchItems.forEach(item => item.classList.remove('active'));
          
          // Add active class to hovered item
          swatchItem.classList.add('active');
          
          // Show loading cursor on both image and container
          this.image.style.cursor = 'wait';
          if (this.imageContainer) {
            this.imageContainer.style.cursor = 'wait';
          }
          
          // Preload the image before changing
          const tempImg = new Image();
          
          tempImg.onload = () => {
            this.image.src = imageUrl;
            this.image.style.cursor = '';
            if (this.imageContainer) {
              this.imageContainer.style.cursor = '';
            }
          };
          
          tempImg.onerror = () => {
            // If image fails to load, still reset cursor
            this.image.style.cursor = '';
            if (this.imageContainer) {
              this.imageContainer.style.cursor = '';
            }
          };
          
          tempImg.src = imageUrl;
        }
  
        handleSwatchLeave() {
          // Return to original image
          this.image.src = this.originalImageSrc;
          
          // Remove active class from all items
          this.swatchItems.forEach(item => item.classList.remove('active'));
          
          // Re-add active class to the originally active item
          if (this.originalActiveItem) {
            this.originalActiveItem.classList.add('active');
          }
        }
  
        disconnectedCallback() {
          // Clean up event listeners
          this.swatchItems.forEach(item => {
            item.removeEventListener('mouseenter', this.handleSwatchHover.bind(this));
            item.removeEventListener('mouseleave', this.handleSwatchLeave.bind(this));
          });
        }
      }
    );
  }
  